// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"1c520309","61":"b319eac0","101":"fe77c561","106":"31c33b87","311":"8fe9305e","344":"819f9a2c","609":"a4e025bf","842":"add5017e"}[chunkId] + ".chunk.js";
};